<script setup>
import { storeToRefs } from 'pinia';
import { useNaavixStore } from '~/naavix/store/naavix.store';

const props = defineProps({
  variant: {
    type: String,
    default: 'mini',
    validator(value) {
      return ['mini', 'full'].includes(value);
    },
  },
});

const emit = defineEmits(['close', 'createNewChat', 'variantChange', 'viewChange']);

const naavix_store = useNaavixStore();
const { get_naavix_agent } = storeToRefs(naavix_store);
</script>

<template>
  <div class="relative flex items-center p-4 border-b border-gray-200">
    <HawkButton
      v-if="props.variant === 'mini'"
      icon
      type="text"
      @click="emit('viewChange', 'all-chats')"
    >
      <IconHawkMenuThree />
    </HawkButton>
    <div v-else />
    <div class="absolute inset-x-0 flex justify-center items-center pointer-events-none">
      <div class="text-sm font-semibold text-gray-900 flex items-center gap-2">
        <IconHawkTaskmapperAi />
        NaaviX
        <template v-if="!get_naavix_agent.is_enabled">
          (disabled)
        </template>
      </div>
    </div>
    <div class="ml-auto flex gap-1">
      <HawkButton
        icon
        type="text"
        @click="emit('variantChange', props.variant === 'full' ? 'mini' : 'full')"
      >
        <IconHawkMaximizeOne v-if="props.variant === 'mini'" />
        <IconHawkMinimizeOne v-else />
      </HawkButton>
      <HawkButton v-if="props.variant === 'mini'" icon type="text" @click="emit('createNewChat')">
        <IconHawkEditFive />
      </HawkButton>
      <HawkButton v-if="props.variant === 'full'" icon type="text" @click="emit('close')">
        <IconHawkXClose />
      </HawkButton>
    </div>
  </div>
</template>
